import { useState } from 'react';
import { useToast } from '../contexts/ToastContext';
import { subscribeToButtondown, validateEmail } from '../services/buttondownService';

export const useEmailSubscription = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();

  const subscribe = async (email) => {
    if (!email || !validateEmail(email)) {
      showToast('Email address is invalid.', 'error');
      return { success: false };
    }

    setIsLoading(true);

    try {
      const result = await subscribeToButtondown(email);
      
      if (result.success) {
        showToast('Successfully subscribed! Thank you for joining our waitlist.', 'success');
        return { success: true };
      } else {
        const errorMsg = typeof result.error === 'string' 
          ? result.error 
          : 'Something went wrong. Please try again.';
        showToast(errorMsg, 'error');
        return { success: false };
      }
    } catch (error) {
      const errorMsg = error?.message || 'Something went wrong. Please try again.';
      showToast(errorMsg, 'error');
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    subscribe,
    isLoading
  };
};
